import * as network from "./network";

const getSavedCustomerData = (params) => {
  return network.get(`getcustomer`, params);
};

export default {
  getSavedCustomerData,
};
